import { getBrowserWidth } from 'owa-config';
import { COLLAPSE_FOLDER_PANE_WHEN_CHAT_OPENED_BREAKPOINT } from '../utils/copilotChatDrawerConstants';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Chat Drawer should only interact with folder pane in certain scenarios.
 * Currently, that is flight on and whether the browser width is below a certain breakpoint.
 */
export function shouldChatCollapseFolderPane(): boolean {
    return (
        isFeatureEnabled('mon-copilot-bizchat-drawer-leftnav-collapse') &&
        getBrowserWidth() < COLLAPSE_FOLDER_PANE_WHEN_CHAT_OPENED_BREAKPOINT
    );
}
